const module = { name: 'shared/global/Fandango.a11y', exports: {} }; const exports = module.exports;

function hideCollapsedElements(parent, selectors) {
    if (!selectors || !parent || !parent.getBoundingClientRect) {
        return;
    }
    const collapsedParent = parent.getBoundingClientRect().top + parent.style.maxHeight;
    if (!collapsedParent) {
        return;
    }
    parent.querySelectorAll(selectors).forEach((element) => {
        if (!element.getBoundingClientRect) {
            return;
        }
        const selectorTop = element.getBoundingClientRect().top;
        if (!selectorTop) {
            return;
        }
        if (selectorTop > collapsedParent) {
            element.setAttribute('tabindex', '-1');
        }
        else {
            element.setAttribute('tabindex', '0');
        }
    });
}
function showCollapsedElements(parent, selectors) {
    if (!selectors || !parent) {
        return;
    }
    parent.querySelectorAll(selectors).forEach((element) => {
        element.setAttribute('tabindex', '0');
    });
}
module.exports = {
    hideCollapsedElements,
    showCollapsedElements
};
export default module.exports;